module.exports = __webpack_public_path__ + "files/ff2fc63e4faf078dfff11a390b8e69b6.svg";